const amountOfSubscriptionsOnPage = 5;

export default amountOfSubscriptionsOnPage;